import "./baseConfig/font.css.ts.vanilla.mjs";
import "./checkbox.css.ts.vanilla.mjs";
var o = "p273__checkbox-2a8b_edc7f1f__14quutu0";
export {
  o as checkboxStyle
};
//# sourceMappingURL=checkbox.mjs.map
